import { render, staticRenderFns } from "./vendor-select-table.vue?vue&type=template&id=53c25634&scoped=true"
import script from "./vendor-select-table.vue?vue&type=script&lang=js"
export * from "./vendor-select-table.vue?vue&type=script&lang=js"
import style0 from "./vendor-select-table.vue?vue&type=style&index=0&id=53c25634&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c25634",
  null
  
)

export default component.exports